import { Amplify } from 'aws-amplify';
import { getCognitoConfig } from '../config';
import { configureDevAuth } from '../core/devAuth';
import { localStorageDevTokenStore } from './devTokenStore';

/**
 * One-time app setup: Amplify's Cognito pool for `stage`, and the dev login
 * bypass gate (`devAuth` is the app's compile-time flag). Call once at module
 * scope before any auth hook renders.
 * - `oauth`: for apps that sign in with Square (`useSquareSignIn`),
 *   the URL Cognito sends the user back to (`getCognitoConfig`).
 */
export const configureAuth = ({
  stage,
  devAuth,
  oauth,
}: {
  stage: string;
  devAuth: boolean;
  oauth?: { redirectUrl: string };
}) => {
  Amplify.configure(getCognitoConfig(stage, oauth));
  configureDevAuth(devAuth, localStorageDevTokenStore);
};

export type { DevLoginRole } from '../config';
export { AuthProviders } from '../core/AuthProviders';
export { signOutApp } from '../core/signOutApp';
export { useAuthStatus } from '../core/useAuthStatus';
export { useDevLogin } from '../core/useDevLogin';
export { useLogin } from '../core/useLogin';
export { hasSignInWithRedirectFailed, useSquareSignIn } from './useSquareSignIn';
